import TagManager from "react-gtm-module";

function EthnicityTooltipConfirm({ ethnicity, ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "ethnicity_tool_tip_confirm",
      ethnicity: ethnicity,
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default EthnicityTooltipConfirm;
